export enum DEVICE_ACTIONS {
    AddDevice = "add device",
    AssignCanPackage = "assign can package",
    AutoSync = "auto sync",
    CreateTask = "create task",
    ExportDeviceData = "export device data",
    GenerateUnlockKey = "generate unlock key",
    ImportDevices = "import devices",
    MoveDevices = "move devices",
    NoTableActions = "no table actions",
    TaskDetails = "task details",
    TransferDevice = "transfer device"
}

export enum GROUP_ACTIONS {
    CreateGroup = "create group",
    DeleteDeviceGroups = "delete device groups",
    EditGroup = "edit group",
    MoveDeviceGroup = "move device group"
}

export enum FILE_ACTIONS {
    DeleteFiles = "delete files",
    UploadFiles = "upload files"
}

export enum COMPANY_ACTIONS {
    CompanyLevelManualChange = "company level manual change",
    CreateCompany = "create company",
    CustomResourceLimits = "custom resource limits",
    DeleteCompanies = "delete companies",
    MergeCompanies = "merge companies",
    TransferCompanies = "transfer companies"
}

export enum USER_ACTIONS {
    DeleteUsers = "delete users",
    EditUser = "edit user",
    InviteUser = "invite user",
    ResendInvitation = "resend invitation"
}

export enum ROLE_ACTIONS {
    CreateRole = "create role",
    DeleteRoles = "delete roles",
    EditRole = "edit role"
}

export enum TASK_GROUP_ACTIONS {
    CancelTasks = "cancel tasks of task group",
    RetryFailedTasks = "retry failed tasks"
}

export enum PRODUCT_CODE_ACTIONS {
    AddProductCode = "add product code",
    DeleteProductCode = "delete product code"
}

export enum LICENSE_ACTIONS {
    CreateDesktopLicense = "create desktop license",
    CreateOfflineLicense = "create offline license",
    DeleteDesktopLicense = "delete desktop license",
    DeleteOfflineLicense = "delete offline license",
    EditDesktopLicense = "edit desktop license"
}

export enum DEVICE_MODEL_ACTIONS {
    CloneModel = "clone model",
    CreateModel = "create model",
    DeleteModels = "delete models",
    EditCompatibility = "edit compatibility",
    EditModel = "edit model"
}

export enum TASK_ACTIONS {
    CancelTasks = "cancel tasks"
}
